export default "__VITE_ASSET__4e9dbdc0__"